export const PLAYER_POSITIONS = {
   CAPTAIN: '(C)',
   SUB: '(S)'
};
// The results of the participants who either did not start or started, but did not reach or were disqualified
export const PLAYER_RESULTS_WHO_COULD_NOT_FINISH = ['DNS', 'DNQ', 'DNF'];
